import React, { useEffect, useState, useRef } from "react";
import * as Style from "./EmploymentInformationStyles";
import helpIcon from "../../../../../assets/IC_Help.png";
import List from "../../../../../newComponents/styledComponents/Table/List";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import swal from "sweetalert";
import "./style/employmeninfo.css";

import { MODULE_API } from "../../../../../apis";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import FETCH from "../../../../../utils/fetch";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import { Table } from "antd";
import DropdownWithButton from "../../../disaster/components/Dropdown/DropdownWithButton";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export const EmploymentInformation = (props) => {
  const [otherIcomesList, setOtherIcomesList] = useState([]);
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [fieldsData, setFieldsData] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("INCOME DETAILS");
  const [submitBody, setSubmitBody] = useState({});
  const [loading, setLoading] = useState(false);
  const [toUpdate, setToUpdate] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [moduleName, setModuleName] = useState(null);
  const [moduleData, setModuleData] = useState([]);
  const inputFileRef = useRef(null);
  const [selectedIncome, setSelectedIncome] = useState(["Other Income"]);
  const [formData, setFormData] = useState({});
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [subModulefields, setSubModuleFields] = useState(null);
  const [Page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [tableData, setTableData] = useState({
    uploadDocumentData: [],
    incomeData: [],
  });
  const [filteredData, setFilteredData] = useState([]);

  console.log("selectedIncome", selectedIncome);
  const history = useHistory();

  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };

  const cols = [
    {
      title: "Name",
      dataIndex: "Income Name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Type Of Income",
      dataIndex: "module",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Amount",
      dataIndex: "Net Amount",
      render: (record) =>
        record
          ? `$ ${record.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "--------",
      // render: (record) =>
      //   record ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => setDropdown(false)}
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    zIndex: "999",
                  }}
                />
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        history.push(`/income_new/attributes/Other%20Income/${record.id}`);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        history.push(`/income_new/attributes/Other%20Income/${record.id}`);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };

  const getAttributes = async (name) => {
    setLoading(true);

    const res = await MODULE_API.fetchAttributes(name);
    if (res) {
      res.attributes &&
        res.attributes.map((attribute) => {
          setLoading(false);
          setFields((prevValue) => {
            return {
              ...prevValue,
              [attribute["groupName"]]: {
                ...(prevValue[attribute["groupName"]] || {}),
                [attribute["id"]]: attribute,
              },
            };
          });
        });
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const moduleNames = ["Employment Information", "Upload Document", "Income"];
  const fetchAllModulesData = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(moduleNames.map((name) => fetchData(name, Page)));
      console.log("All module results:", results);
      const empInfoModule = results.find((item) => item.moduleName === "Employment Information");
      if (empInfoModule) {
        const targetRecord = empInfoModule.records.find(
          (record) => record.subType === "Disability" || "Current Employer" in record
        );
        setFieldsData(targetRecord);
      } else {
        console.log("Employment Information module not found");
      }

      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchData = async (moduleName, page) => {
    try {
      setLoading(true);
      setPage(page);
      console.log("Pageeee in Fetch", Page);
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: page || 1,
        limit: 10,
        body: {},
      });
      console.log("ressssssssssss", res);
      const records = res.records || [];
      console.log("recordssssssss", records);
      if (moduleName === "Other Income") {
        const pagenum = res.pagination.page;
        const total = res.pagination.total;
        if (total) {
          const totalPages = Math.ceil(total / 10); // or use a `limit` variable if dynamic
          setTotalPages(totalPages);
        }
        setLoading(false);

        return { moduleName, records, pagenum, total }; // Return object with moduleName to map later
      }
      setLoading(false);
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    }
  };
  const deleteRecord = async (record) => {
    try {
      setLoading(true);
      console.log("recorddddddddddddd", record);
      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      const res = await fetchData(record.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      const res = await fetchData(formData.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(formData.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset("Employment Information", {
        clientModules: [formData],
      });
      console.log("result", result);
      setLoading(false);
      setToUpdate(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleImageUpload = async (event) => {
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      let objToSubmit = {
        "Document Upload": res,
        "Uploaded File Name": name,
      };
      handleSubmit(objToSubmit);
    }
    if (inputFileRef && inputFileRef.current) {
      inputFileRef.current.value = null;
    }
  };
  const handleSubmit = async (body) => {
    console.log("Submit...", body);
    try {
      setLoading(true);
      const response = await MODULE_API.addAsset(moduleName, {
        clientModules: [body],
      });
      console.log("resposnse Upload", response);
      if (response && response.message) {
        swal("Success!", response.message, "success");
      }
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
      console.log("error in update", error);
    } finally {
      setLoading(false);
    }
  };
  const uploadDocCols = [
    {
      title: "Document Name",
      dataIndex: "Uploaded File Name",
      key: "Uploaded File Name",
      render: (fileName, record) => {
        return record["Document Upload"] ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a style={{ color: "#7d8fb3" }} href={record["Document Upload"]} target="blank">
              {" "}
              {record["Uploaded File Name"] || extractFileNameFromUrl(record["Document Upload"])}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => setDropdown(false)}
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    zIndex: "999",
                  }}
                />
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        window.open(record["Document Upload"]);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const incomeOptions = [
    { label: "Self - Employment", value: "Self - Employment" },
    { label: "Earned Income from Work", value: "Earned Income from Work" },
    { label: "Military Benefits", value: "Military Benefits" },
    { label: "Pension", value: "Pension" },
    { label: "Distribution from Asset", value: "Distribution from Asset" },
    { label: "Insurance Payout", value: "Insurance Payout" },
    { label: "Settlement (Structured & Lump)", value: "Settlement (Structured & Lump)" },
    { label: "Alimony", value: "Alimony" },
    { label: "Annuity Non-Investment Income", value: "Annuity Non-Investment Income" },
    { label: "Disability Income Payments", value: "Disability Income Payments" },
    { label: "Reverse Mortgage", value: "Reverse Mortgage" },
    { label: "Social Security", value: "Social Security" },
    { label: "Real Estate Rental", value: "Real Estate Rental" },
    { label: "RMD Distribution", value: "RMD Distribution" },
    { label: "Other Income", value: "Other Income" },
  ];
  useEffect(() => {
    setModuleName("Employment Information");
    setSelectedIncome(["Other Income"]);
    getAttributes(props.activeStep.name);
    fetchAllModulesData();
    filterIncomeData();
    // getModulesDocs("Upload Document");
    // getIncomeList();
  }, []);
  useEffect(() => {
    if (fieldsData && fieldsData.id) {
      setToUpdate(true);
    }
  }, [fieldsData]);

  useEffect(() => {
    setTabs(Object.keys(fields));
  }, [fields]);
  useEffect(() => {
    let tabs2 = tabs.map((item) => item.toUpperCase());
    let temp = tabs2.indexOf(activeTabName);
    if (temp !== -1) {
      setActiveTabIndex(temp);
    }
  }, [activeTabName]);
  const handleSelect = (e) => {
    e.persist();
    setSelectedIncome((prev) => [...prev, e.target.value]);
  };
  const filterIncomeData = () => {
    const filteredData = []; // Initialize empty array

    // Check if we have data to filter
    if (!tableData.incomeData || !selectedIncome) {
      return tableData.incomeData || []; // Return original or empty array
    }

    // Push matching items into the new array
    tableData.incomeData.forEach((item) => {
      console.log("item.module", item.module);
      if (selectedIncome.includes(item.module)) {
        filteredData.push(item);
      }
    });
    setFilteredData(filteredData);
    return;
  };
  return (
    <div>
      <div style={{ marginBottom: "2rem" }} className="input-fields-container">
        <Style.MainHeading style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
              Employment Information 
              <ToolTipCreator name={"Disability_Employment_Information"}/>
            </div>
            {/* <Style.HelpIcon src={helpIcon} alt="helpicon" /> */}
          </div>
        </Style.MainHeading>

        {tabs.length > 0 && (
          <DisabilityFormCreator
            data={fields[tabs[activeTabIndex]]}
            values={fieldsData}
            title={tabs[activeTabIndex]}
            setSubmitBody={setFormData}
            activeTabName={activeTabName}
          />
        )}
        {fields && (
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={() => {
                if (toUpdate) {
                  updateRecord();
                } else {
                  createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        )}
        <NewLoader isLoading={loading} />
      </div>

      <Style.MainHeading>
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          Other Income 
          <ToolTipCreator name={"Disability_Other_Income"}/>
        </div>
        {/* <Style.HelpIcon src={helpIcon} alt="helpicon" onClick={() => {}}></Style.HelpIcon> */}
      </Style.MainHeading>
      <div>
        <div className="dropdown-main-container">
          <div class="dropdown-wrapper">
            <select
              class="dropdown-select"
              id="dropdown-select"
              value={selectedIncome[selectedIncome]}
              onChange={handleSelect}
              name="options"
            >
              <option value="" disabled selected>
                Select Type Of Income
              </option>
              {incomeOptions &&
                incomeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
            </select>
          </div>
          <div className="dropdown-add-button-container">
            <button className="dropdown-add-button" onClick={filterIncomeData}>
              Show
            </button>
          </div>
        </div>
      </div>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Other Income</Style.Title>
          <div>
            <Style.Button
              onClick={() => {
                history.push("/income_new/attributes/Other%20Income", { from: "/protector/disability" });
              }}
            >
              +
            </Style.Button>
          </div>
        </Style.HealthCardHeader>
        <div style={{ position: "relative", marginTop: "0.5rem" }}>
          <Table
            columns={cols}
            dataSource={filteredData}
            pagination={{
              total: totalPages * 10, // Assuming 10 items per page
              current: Page,
              pageSize: 10,
              onChange: async (page) => {
                console.log("pageeeeeeeeeeee", page);
                const modulName = "Income";
                const res = await fetchData(modulName, page);
                setTableData((prev) => ({
                  ...prev,
                  [formatModuleKey(modulName)]: res.records || [],
                }));
              },
            }}
          />
          <NewLoader isLoading={loading} />
        </div>
      </Style.HealthCard>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>
            Upload Document <Style.HelpIcon src={helpIcon} alt="helpicon"></Style.HelpIcon>
          </Style.Title>
          <div>
            <input
              type="file"
              id="UploadDocument"
              ref={inputFileRef}
              hidden
              onChange={async (event) => {
                console.log("onchangeeeeeeeeee", event);
                await handleImageUpload(event);
              }}
              accept="image/jpeg, .pdf, .xlsx, .doc"
            />
            <Style.Button
              htmlFor="UploadDocument"
              onClick={() => {
                setModuleName("Upload Document");
              }}
              style={{ cursor: "pointer", pointerEvents: loading && "none" }}
            >
              +
            </Style.Button>
          </div>
        </Style.HealthCardHeader>
        <div className="employment-info-table-contanier">
          <Table columns={uploadDocCols} dataSource={tableData.uploadDocumentData} />
          <NewLoader isLoading={loading} />
        </div>
      </Style.HealthCard>
    </div>
  );
};
